type ExportableMimes = "text/csv" | "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const downloadFileFromBlob = (data: Blob, filename: string, mime: ExportableMimes) => {
  const blob = new Blob([data], { type: mime });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
